import { AfterContentInit, Component, Inject, NgZone } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import * as dayjs from 'dayjs';
import { SurveySnackBarComponent } from '@go-modules/components/snack-bars/survey/survey-snack-bar.component';
import { CustomerSurveySnackBarComponent } from '@go-modules/components/snack-bars/customer-survey/customer-survey-snack-bar.component';
import { UserService as NgxUserService } from '@go-modules/services/user/user.service';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';

@Component({
	selector: 'ai-trial-survey-snack-bar',
	templateUrl: 'ai-trial-survey-snack-bar.component.html',
	styleUrls: ['./ai-trial-survey-snack-bar.component.scss'],
	standalone: false
})
export class AiTrialSurveySnackBarComponent extends SurveySnackBarComponent implements AfterContentInit {
	public form = new UntypedFormGroup({
		rating: new UntypedFormControl(null, [Validators.required]),
		feedback: new UntypedFormControl(''),
		invite: new UntypedFormControl('AI Trial')
	});

	constructor (
		protected ngxUserService: NgxUserService,
		protected snackbarRef: MatSnackBarRef<SurveySnackBarComponent>,
		protected ngxGoToastService: NgxGoToastService,
		protected snackbar: MatSnackBar,
		protected ngZone: NgZone,
		@Inject(userServiceToken) protected userService: UserService
	) {
		super(
			ngxUserService,
			snackbarRef,
			ngxGoToastService,
			snackbar,
			ngZone,
			userService
		);
	}

	public static override get localStorageKey (): string {
		return 'ai-trial-survey';
	}

	public static override open (snackBar: MatSnackBar) {
		return snackBar.openFromComponent(
			AiTrialSurveySnackBarComponent,
			{
				panelClass: 'snack-bar-panel',
				horizontalPosition: 'end'
			}
		);
	}

	public static override canShow (userId) {
		const newKey = localStorage.getItem(`${userId}-${AiTrialSurveySnackBarComponent.localStorageKey}`);
		return !newKey;
	}

	public override ngAfterContentInit (): void {
		this.hasProjectedContent = true;
		const { user_id } = this.userService.currentUser;
		localStorage.setItem(`${user_id}-${AiTrialSurveySnackBarComponent.localStorageKey}`, '1');

		// prevent the customer survey from showing for another 3 months
		localStorage.setItem(`${user_id}-${CustomerSurveySnackBarComponent.localStorageKey}`, dayjs().add(90, 'day').toString());
	}

	public onClose () {
		// prevent an occasional issue where it doesnt close immediately
		this.ngZone.run(() => {
			this.snackbarRef.dismiss();
		});
	}

	public onSubmit () {
		if (this.form.valid) {
			this.ngZone.run(() => {
				this.snackbarRef.dismiss();
			});
			this.ngxUserService.sendFeedback(
				this.form.controls.rating.value,
				this.form.controls.feedback.value,
				this.form.controls.invite.value
			)
				.subscribe({
					next: () => {
						this.ngxGoToastService.createToast({
							type: GoToastStatusType.SUCCESS,
							message: 'customer-feedback-thanks'
						});
					},
					error: () => {
						// re open
						AiTrialSurveySnackBarComponent.open(this.snackbar);
						this.ngxGoToastService.createToast({
							type: GoToastStatusType.ERROR,
							message: 'customer-feedback-error'
						});
					}
				});
		}
	}
}
